import type { Component } from '@boss/types/corporate-jobs';
import { Image as CfImage, Quote, Video } from '@boss/ui';

import { specialQuoteCarousel } from '../../utils/options';
import ComponentMapper from '../ComponentMapper';
import { getImageProps, getQuoteCarouselProps, getVideoProps } from '../PropsMapping';

type Props = {
  entry: Component;
  inline?: boolean;
  locale: string;
};

const Mapper = ({ entry, locale }: Props): JSX.Element | null => {
  if (entry.__typename === 'image') {
    return <CfImage {...getImageProps(entry)} />;
  }

  if (entry.__typename === 'video') {
    return <Video {...getVideoProps(entry)} />;
  }

  if (entry.__typename === 'quote' && specialQuoteCarousel) {
    return <Quote variant="carousel" {...getQuoteCarouselProps(entry)} />;
  }

  return <ComponentMapper entry={entry} locale={locale} />;
};

const CarouselMapper = ({ inline, ...props }: Props) => {
  const body = <Mapper {...props} />;

  return inline ? <span className="inline">{body}</span> : body;
};

export default CarouselMapper;
